<div class="help-page__header help-page__header--sub-header">
  {{ 'help-page.imprint' | translate }}
</div>
<div (click)="closeImprint()" class="icon-close help-page__content--close-button" genericButton></div>
<div class="help-page__content" [innerHTML]="empSpecificContents.imprint"></div>
